import Moment from "moment";

const leaderBoardReducer = (state= {items:[]},action)=>{
    switch (action.type) {
        case 'LEADERBOARD':
            return {
                items: [ action.payload],

            };
        case 'LEADERBOARD_ADD':

            let items =[...state.items,action.payload]


            return {
                items: items,

            };
        default:
            return state;

    }
}
export default leaderBoardReducer;